import { config } from 'util/config';

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ addChecklistFromTemplateShow: true });
  setTimeout(() => {
    pageComponent.addChecklistFromTemplate.current?.additionalFormRef.current?.child.current?.getChecklistTemplateData();
    pageComponent.addChecklistFromTemplate.current?.getChecklistTemplatePresetDataSource();
  }, config.setTimeoutMilliSecond);
}
